<template>
    <div>
        <form>
            <address-form
                ref="addressForm"
                :early-invoice-text="mode === 'business' && 'Wir möchten unsere Bestellung jeweils vor 10 Uhr morgens erhalten.<br>Der Aufpreis für die Öpfelchasper-Frühlieferung beträgt 5 CHF pro Lieferung.'"
                firm-required
            />
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import AddressForm from '../Forms/Address.vue';

export default {
    components: {
        AddressForm,
    },
    computed: {
        ...mapState({
            mode: state => state.mode,
        }),
    },
    mounted() {
        // hide #order-header, #order-description
        // $('#order-header, #order-description, .hamburger').addClass('hidden');

        /* disable brand logo link
        $('.brand-logo__link').attr('href', '#');

        // move disturber footer above order app
        const $disturberFooter = $('#order-disturber--footer');
        const $orderPlaceholder = $('#order-placeholder');

        if ($('#order-disturber--header').length === 0) {
            const $disturberHeader = $disturberFooter.clone().attr('id', 'order-disturber--header').removeClass('hidden');
            $orderPlaceholder.before($disturberHeader);
            $disturberFooter.addClass('hidden');
        } */

        // GTM VirtualPageview
        const { dataLayer } = window;
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: 'VirtualPageview',
                virtualPageURL: `/de/${this.mode === 'business' ? 'bio-furs-buro' : 'bio-fur-dihei'}/adresse`,
                virtualPageTitle: `Abo Bestellen ${this.mode === 'business' ? 'Büro' : 'Zuhause'} - Adresse`,
            });
        }
    },
};
</script>




// WEBPACK FOOTER //
// Address.vue?6fc02039